import React from "react";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import Toolbar from "@mui/material/Toolbar";
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
const Image = styled.img`
  width: 150px;
  height: 150px;
  resize-mode: contain;
  padding: 10px;
  border-radius: 30px;
`;
const CategoriesList = ({ categories }) => {
  const theme = useTheme();
  const history = useHistory();
  const { t , i18n} = useTranslation();
  const isDrawerOpen = useSelector((state) => state.auth.isDrawerOpen);
  const RenderCategory = ({ item , index }) => (
    <Link
      color="inherit"
      style={{
        cursor: "pointer",
        
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
      }}
      variant="div"
      onClick={() => history.push("/categories/" + item.id)}
      sx={{ p: 1, flexShrink: 1 }}
    >
      <Image
        style={{
          backgroundColor: theme.dark.rgbPrimaryLight.replace("##", "0.1"),
          border: "1px solid #fac904",
        }}
        alt={"category image card "}
        src={item.image}
      />
      <Typography
        variant="body2"
        align="center"
        color="text.secondary"
        component="p"
        style={{ fontWeight: "bold" }}
      >
        {i18n.language === "en" ? item.titleEn :item.titleAr }
      </Typography>
    </Link>
  );
  
  return (
    <Toolbar
      component="div"
      variant="dense"
      //  paddingLeft :isDrawerOpen &&categories &&categories.length >5 ? 870:categories &&categories.length <=5?0:650,
      style={{ justifyContent: "center", overflowX: "auto", marginTop: '10vh',width:"100%"  }}
      sx={{ p: 1, flexShrink: 1 }}
      //sx={{ }}
    >
      {categories.map((item, index) => (
        <RenderCategory index={index} item={item} key={"category image card : " + index} />
      ))}
    </Toolbar>
  );
};

export default CategoriesList;
